import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Step4 } from '../../components/examples/game-of-life';
import GridAPI from '../api/grid.mdx';
export const _frontmatter = {
  "Title": "Grid"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Grid is a `}<a parentName="p" {...{
        "href": "/react-sim/frame-helpers"
      }}>{`frame helper`}</a>{` which displays any 2-dimensional matrix of data as a grid of colored squares.`}</p>
    <Step4 mdxType="Step4" />
    <p>{`It's used in examples like `}<a parentName="p" {...{
        "href": "/react-sim/examples/game-of-life"
      }}>{`Game of Life`}</a>{`, `}<a parentName="p" {...{
        "href": "/react-sim/examples/simple-model"
      }}>{`Simple Model`}</a>{` or `}<a parentName="p" {...{
        "href": "/react-sim/examples/activators-inhibitors"
      }}>{`Activators/inhibitors`}</a>{`.`}</p>
    <h1 {...{
      "id": "properties"
    }}>{`Properties`}</h1>
    <GridAPI mdxType="GridAPI" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      